import axios from 'axios';
import Promise from 'promise-polyfill';

import { Modal, Button } from 'antd';

import FileSaver from 'file-saver';

const API_Error = (error) => {
  alert(error);
  return false;
};

const WPLE_API = (action, payload = {}) => {
  return new Promise((resolve, reject) => {
    const endpoint = 'https://api.wpencryption.com/v4/';
    let params = {
      type: action,
      site: WPLEAPP.site,
      licenseid: WPLEAPP.lid,
      pki: WPLEAPP.http,
      ...payload,
    };

    if (payload.domain && payload.domain != '' && action == 'approvers') {
      params.site = payload.domain;
    }
    ///console.log(params);

    try {
      switch (action) {
        case 'status':
        case 'approvers':
        case 'initiateorder':
        case 'orderstatus':
        case 'resendverificationemail':
        case 'comodoterms':
        case 'getorders':
        case 'getordersupdatestatus':
        case 'setemailauth':
          axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: endpoint,
            data: params,
          }).then((response) => {
            if (response.data === null) {
              //approvers
              resolve({});
            } else if (response.data.error) {
              let errmsg = response.data.error.msg;

              let warningObj = {
                title: 'Caught Error during action: ' + action + '!',
                closable: true,
                content: response.data.error.msg,
              };

              if (errmsg.indexOf('reached the limit') > 0) {
                warningObj.footer = (
                  <Button
                    type="primary"
                    className="quotabuy"
                    key="link"
                    href={
                      WPLEAPP.site +
                      '/wp-admin/admin.php?page=wp_encryption-pricing&checkout=true&plan_id=8210&plan_name=pro&billing_cycle=annual&pricing_id=7965&currency=usd'
                    }>
                    Buy Quota
                  </Button>
                );
              }

              Modal.warning(warningObj);
              reject('error');
            } else {
              resolve(response.data);
            }
          });
          break;
        case 'downloadsslzip':
          var formdata = new FormData();
          formdata.append('type', 'downloadsslzip');
          formdata.append('site', WPLEAPP.site);
          formdata.append('licenseid', WPLEAPP.lid);
          formdata.append('orderid', payload.orderid);

          fetch(endpoint, {
            method: 'POST',
            //mode: 'cors',
            cache: 'no-cache',
            // headers: {
            //   Accept: 'application/json',
            // },
            // headers: {
            //   'Content-Type': 'application/x-www-form-urlencoded',
            // },
            redirect: 'follow',
            body: formdata,
          })
            .then((response) => {
              const contentType = response.headers.get('content-type');

              if (
                contentType &&
                contentType.indexOf('application/json') !== -1
              ) {
                //let data = response.json();
                throw new Error('Download Failed');
              } else {
                return response.blob();
              }
            })
            .then((zip) => {
              var blob = new Blob([zip], {
                type: 'application/zip',
              });
              FileSaver.saveAs(blob, payload.orderid + '.zip');
              resolve('ok');
            })
            .catch((Error) => {
              alert(Error);
              resolve('ok');
            });

          // axios({
          //   method: 'post',
          //   //responseType: 'blob',
          //   //withCredentials: true,
          //   headers: {
          //     'Content-Type': 'application/x-www-form-urlencoded',
          //   },
          //   url: endpoint,
          //   data: params,
          // })
          //   .then((response) => {
          //     // const url = window.URL.createObjectURL(
          //     //   new Blob([response.data.extra])
          //     // );
          //     // const link = document.createElement('a');
          //     // link.href = url;
          //     // link.setAttribute('download', 'certfile.zip'); //or any other extension
          //     // document.body.appendChild(link);
          //     // link.click();

          //     var blob = new Blob([response.data], {
          //       type: 'application/zip',
          //     });
          //     FileSaver.saveAs(blob, 'mycrt.zip');

          //     // resolve(response.data);
          //     resolve('ok');
          //   })
          //   .catch((error) => {
          //     let statusCode = error.response.status;
          //     let responseObj = error.response.data.text();

          //     console.log(responseObj);
          //   });
          break;
        case 'downloadprivatekey':
          var formdata = new FormData();
          formdata.append('type', 'downloadprivatekey');
          formdata.append('site', WPLEAPP.site);
          formdata.append('licenseid', WPLEAPP.lid);
          formdata.append('orderid', payload.orderid);

          fetch(endpoint, {
            method: 'POST',
            cache: 'no-cache',
            redirect: 'follow',
            body: formdata,
          })
            .then((response) => response.json())
            .then((res) => {
              if (res.error) {
                Modal.warning({
                  title: 'Failed downloading private key!',
                  content: response.error.msg,
                });
              } else {
                var blob = new Blob([res.success], {
                  type: 'text/plain;charset=utf-8',
                });
                FileSaver.saveAs(blob, payload.orderid + '.pem');
                resolve('ok');
              }
            })
            .catch((Error) => {
              alert(Error);
              resolve('ok');
            });
          break;
        default:
          break;
      }
    } catch (error) {
      API_Error(error); //reject
    }
  });
};

export { WPLE_API };
